import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import _ from "lodash";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import { useDispatch, useSelector } from "react-redux";

import {
  saasDestinations,
  saasDestinationSlugs,
} from "./destinations/destinations";
import Navigation from "./Navigation.js";
import DestinationsList from "./components/DestinationsList";
import { SET_SINGLE_DESTINATION_CONFIG } from "./reducers/destinations";

const useStyles = makeStyles(() => ({
  content: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  inner: {
    minWidth: 700,
  },
  switchContainerHidden: {
    visibility: "hidden",
  },
  card: {
    width: "65%",
    minWidth: 800,
  },
  navigation: {
    paddingTop: 24,
  },
  clickableImg: {
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function DestinationsListPage({ filter }) {
  let filteredDestinations = _.chain(saasDestinations)
    .values()
    .sortBy((dest) => saasDestinationSlugs.indexOf(dest.slug))
    .value();
  if (filter) {
    filteredDestinations = _.filter(
      filteredDestinations,
      (dest) => dest.type === filter
    );
  }
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const configuredDestinations = useSelector(
    (state) => state.destinations.data
  );

  const setConfiguredDestinations = (destConfig) => {
    dispatch({ type: SET_SINGLE_DESTINATION_CONFIG, payload: destConfig });
  };

  function handleConfigureDest(dest) {
    history.push(dest.configPageUrl());
  }

  let breadcrumbType = "Apps";
  if (filter === "advertising") {
    breadcrumbType = "Advertising";
  } else if (filter === "cohorting") {
    breadcrumbType = "Cohorting";
  }

  return (
    <Navigation className={clsx(classes.navigation)}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className={clsx(classes.breadcrumb)}
      >
        {filter ? (
          <Link color="inherit" onClick={() => history.push(`/destinations`)}>
            <Typography className={clsx(classes.lightText)} variant="overline">
              Destinations
            </Typography>
          </Link>
        ) : (
          <Typography className={clsx(classes.darkText)} variant="overline">
            Destinations
          </Typography>
        )}
        {filter && (
          <Typography className={clsx(classes.darkText)} variant="overline">
            {breadcrumbType}
          </Typography>
        )}
      </Breadcrumbs>
      <Typography component="h1" gutterBottom variant="h3">
        Connect all your analytics and marketing tools
      </Typography>

      <DestinationsList
        destinations={filteredDestinations}
        configuredDestinations={configuredDestinations}
        onConfigure={(dest) => handleConfigureDest(dest)}
        onConfiguredDestsChange={(state) => setConfiguredDestinations(state)}
      />
    </Navigation>
  );
}

DestinationsListPage.propTypes = {
  filter: PropTypes.oneOf([null, "app", "advertising", "cohorting"]),
};

export default DestinationsListPage;
